import { toast } from 'react-toastify';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import * as actions from './Actions';
import * as api from './Api';
import Types from './Types';

function* getAllAnnouncements({ payload }) {
    try {
        yield put(actions.addAnnouncementLoading(true));
        const result = yield call(api.getAllAnnouncements);
        // Handle both direct array response or wrapped in data property
        const data = Array.isArray(result.data) ? result.data : (result.data?.data || result.data || []);
        yield put(actions.getAllAnnouncementsSuccess({ data }));
    } catch (error) {
        const { response, message } = error;
        toast.error(error);
        yield put(actions.getAllAnnouncementsFail());
    } finally {
        yield put(actions.addAnnouncementLoading(false));
    }
}

//Edit Announcement
function* editAnnouncement(data) {
    try {
        yield put(actions.addAnnouncementLoading(true));
        const result = yield call(api.editAnnouncement, data.payload);
        // API returns { status, message, announcement }
        // Extract announcement and wrap in { data: ... } for reducer
        const announcementData = result.data?.announcement || result.data;
        if (announcementData) {
            yield put(actions.editAnnouncementSuccess({ data: announcementData }));
            toast.success(result.data?.message || 'Edit Successfully');
            data?.action && data?.action();
        } else {
            throw new Error('Invalid response structure');
        }
    } catch (error) {
        yield put(actions.editAnnouncementFail());
        const errorMessage = error?.response?.data?.message || error?.message || 'Failed to update announcement';
        toast.error(errorMessage);
    } finally {
        yield put(actions.addAnnouncementLoading(false));
    }
}

// create
function* createAnnouncement(formData) {
    try {
        yield put(actions.addAnnouncementLoading(true));
        const result = yield call(api.createAnnouncement, formData.payload);
        yield put(
            actions.createAnnouncementSuccess({
                data: result.data
            })
        );
        toast.success('Created Successfully');
        formData?.action && formData?.action()
    } catch (error) {
        yield put(actions.createAnnouncementFail());
        toast.error(error?.response?.data?.message || 'Failed to create announcement');
    } finally {
        yield put(actions.addAnnouncementLoading(false));
    }
}

function* deleteAnnouncement({ payload }) {
    try {
        yield put(actions.addAnnouncementLoading(true));
        const result = yield call(api.deleteAnnouncement, payload);

        yield put(actions.deleteAnnouncementSuccess(payload));

        toast.success('Deleted Successfully');
    } catch (error) {
        const { response, message } = error;
        toast.error(error.response);
        yield put(actions.deleteAnnouncementFail());
    } finally {
        yield put(actions.addAnnouncementLoading(false));
    }
}

function* activateAnnouncement({ payload }) {
    try {
        yield put(actions.addAnnouncementLoading(true));
        const result = yield call(api.activateAnnouncement, payload);
        // API returns { status, message, announcement }
        // Extract announcement and wrap in { data: ... } for reducer
        const announcementData = result.data?.announcement || result.data;
        if (announcementData) {
            yield put(actions.activateAnnouncementSuccess({ data: announcementData }));
            toast.success(result.data?.message || 'Status Updated Successfully');
        } else {
            throw new Error('Invalid response structure');
        }
    } catch (error) {
        const { response, message } = error;
        const errorMessage = error?.response?.data?.message || error?.message || 'Failed to update status';
        toast.error(errorMessage);
        yield put(actions.activateAnnouncementFail());
    } finally {
        yield put(actions.addAnnouncementLoading(false));
    }
}

export default function* AnnouncementSaga() {
    yield takeLatest(Types.GET_ANNOUNCEMENTS_REQUEST, getAllAnnouncements);
    yield takeLatest(Types.EDIT_ANNOUNCEMENT_REQUEST, editAnnouncement);
    yield takeLatest(Types.CREATE_ANNOUNCEMENT_REQUEST, createAnnouncement);
    yield takeLatest(Types.DELETE_ANNOUNCEMENT_REQUEST, deleteAnnouncement);
    yield takeLatest(Types.ACTIVATE_ANNOUNCEMENT_REQUEST, activateAnnouncement);
}

